var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.currentView==='webList')?_c('web-list'):(_vm.currentView==='accessCode')?_c('access-code'):(_vm.currentView==='addWeb')?_c('add-web'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }